import { userConstants } from './constantData';

export const PARENTAL_CONTROL_DATA = {
  allow_content: {
    page_view: {
      hash: 'p-042.143.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    back: {
      hash: 'e-042.143.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    continue: {
      hash: 'e-042.143.001.000.000.101',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  block_content: {
    page_view: {
      hash: 'p-041.023.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_content_name',
        'v_content_type',
        'v_content_id',
        'v_genre',
        'v_play_source',
        'v_start_progress_bar',
        'v_channel_name',
        'v_serie_name',
        'v_season',
        'v_video_subtitle',
        'v_video_language',
        'v_error_code',
        'v_section_name',
        'v_transmission_type',
        'v_collection_name',
        'v_error_type',
        'v_component_type',
        'v_channel_id',
        'v_episode_number',
        'v_content_player_type',
        'v_episode_name',
        'v_vertical_position_carousel',
        'v_is_sports',
        'v_content_age_rating',
        'v_age_restricted_content',
        'v_video_duration',
        'v_start_video_percentual',
      ],
    },
    ok: {
      hash: 'e-041.023.001.000.000.154',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
      ],
    },
    consult_schedule: {
      hash: 'e-041.023.001.000.000.258',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
      ],
    },
    back: {
      hash: 'e-041.023.001.000.000.028',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
      ],
    },
    close: {
      hash: 'e-041.023.001.000.000.008',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
      ],
    },
  },
};
